import { BaseDto } from '../base-dto';
import { AvatarDto } from './avatar-dto';

// The shell only consumes these fields from the existing AccountDto response.
// Private profile/medical details are not retained in session state.
export class AccountDto extends BaseDto {
  public name = '';
  public email = '';
  public username = '';
  public isNewAccount = false;
  public isChildAccount = false;
  public isParentLocked = false;
  public avatar?: AvatarDto;
}

// Deliberately whitelist shell fields; never spread a complete private profile into session state.
export function accountForSession(source: AccountDto): AccountDto {
  return Object.assign(new AccountDto(), {
    id: source.id, createdAt: source.createdAt, name: source.name,
    email: source.email, username: source.username, avatar: source.avatar,
    isNewAccount: source.isNewAccount, isChildAccount: source.isChildAccount,
    isParentLocked: source.isParentLocked
  });
}
